module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_04_6DD79_1SE_GAZ.6d72e88c.png";